import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Footer from "../components/Footer";
import {
    GuardianProposition,
    FourStagePathway,
    FlexibleEngagement,
    Orientation,
    CompactCredibilityProof,
    ProfessionalReporting,
    GuardianProgramTransition,
    AuthorityArticles,
    HomeFinalCTA,
} from "../components/HomeSectionsV2";
import { HomeClientExperience } from "../components/ClientReviews";
import usePageMeta from "../hooks/usePageMeta";
import useFAQSchema from "../hooks/useFAQSchema";
import { FAQ_HOME } from "../data/faqs";

/**
 * Home — 2026-08 marketing-flow release-candidate order.
 *
 * The homepage must communicate SRM's proposition within the first short
 * scroll. Every section directly serves the visitor's understanding of the
 * Guardian Program and how to engage SRM. No credibility strip below the
 * hero; no duplicate independence/audience sections; one final CTA.
 *
 * Section order (locked by the executive brief):
 *   1.  Hero
 *   2.  Guardian proposition
 *   3.  Four-stage Guardian pathway
 *   4.  Flexible engagement
 *   5.  What SRM assesses (2 cards)
 *   6.  Compact credibility proof
 *   7.  Reporting standard
 *   8.  Guardian Program transition
 *   9.  Authority articles (three Amanda pieces)
 *  10.  One final CTA
 */
export default function Home() {
    usePageMeta({
        title: "Independent Strata Roof Assessment & Asset Management | SRM",
        description:
            "SRM provides independent roof and external-building assessments, condition reports, tender support, delivery oversight and ongoing roof asset management for strata and body corporate communities.",
        keywords:
            "independent strata roof assessment, body corporate roof assessment, strata roof condition report, strata roof asset management, roof condition assessment Queensland, Guardian Program",
        breadcrumbs: [{ name: "Home", url: "/" }],
    });
    useFAQSchema("home", FAQ_HOME);

    return (
        <div data-testid="home-page" className="min-h-screen bg-white">
            <Navbar />
            <main id="main">
                <Hero />
                <GuardianProposition />
                <FourStagePathway />
                <FlexibleEngagement />
                <Orientation />
                <CompactCredibilityProof />
                <ProfessionalReporting />
                <GuardianProgramTransition />
                <HomeClientExperience />
                <AuthorityArticles />
                <HomeFinalCTA />
            </main>
            <Footer />
        </div>
    );
}
